import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProjectContext } from './ProjectContext';
import { toast } from 'react-toastify';

const DeleteProject = ({ setCurrentView }) => {
  const { selectedProject, deleteProject, setSelectedProject } = useContext(ProjectContext);
  const navigate = useNavigate();
  const [confirmationText, setConfirmationText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  if (!selectedProject) {
    navigate('/admin');
    return <p className="text-center text-red-600 mt-20">No project selected.</p>;
  }

  const handleDelete = async (e) => {
    e.preventDefault();
    if (confirmationText.trim() !== selectedProject.title.trim()) {
      setErrorMessage('Project title does not match.');
      return;
    }

    setIsDeleting(true);
    setErrorMessage('');
    try {
      await deleteProject(selectedProject.id);
      console.log('DeleteProject: Before toast.success');
      toast.success('Project deleted successfully!', {
        position: 'bottom-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: 'bg-blue-600 text-white',
      });
      console.log('DeleteProject: After toast.success');
      setSelectedProject(null);
      setCurrentView('read');
      navigate('/admin');
    } catch (error) {
      console.error('Deletion Error:', error);
      console.log('DeleteProject: Before toast.error');
      toast.error(`Error: ${error.message}`, {
        position: 'bottom-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: 'bg-red-600 text-white',
      });
      console.log('DeleteProject: After toast.error');
      setErrorMessage(`Error: ${error.message}`);
    } finally {
      setIsDeleting(false);
    }
  };

  const isTitleMatch = confirmationText.trim() === selectedProject.title.trim();

  return (
    <section className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="bg-white rounded-3xl shadow-lg p-8 max-w-md w-full">
        <h2 className="text-2xl font-light text-gray-900 mb-6">
          Delete Project
        </h2>
        <p className="text-gray-700 mb-6">
          Are you sure you want to delete "{selectedProject.title}"? This action cannot be undone.
        </p>
        <p className="text-gray-700 mb-2">
          Type the project title <strong>{selectedProject.title}</strong> to confirm:
        </p>
        <form onSubmit={handleDelete}>
          <div className="mb-6">
            <input
              type="text"
              value={confirmationText}
              onChange={(e) => setConfirmationText(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 border-gray-300"
              placeholder="Enter project title"
              autoFocus
            />
          </div>
          {errorMessage && (
            <p className="text-center text-red-600 mb-4">{errorMessage}</p>
          )}
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={() => setCurrentView('read')}
              className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-all"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isDeleting || !isTitleMatch}
              className={`px-6 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-all ${isDeleting || !isTitleMatch ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {isDeleting ? 'Deleting...' : 'Delete Project'}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default DeleteProject;